export default "__VITE_ASSET__CXmbhfbm__"